<xemex-card-grid>
  <xemex-card [title]="'companies.detailTabs.general.label' | translate">
    <div class="grid grid-cols-2 gap-4">
      <xemex-detail-field
        [label]="'companies.detailTabs.general.vat' | translate"
        [loading]="isLoading()"
      >
        {{ companyDetail()?.partnerVat }}
      </xemex-detail-field>
      <xemex-detail-field
        [label]="'companies.detailTabs.general.kvk' | translate"
        [loading]="isLoading()"
      >
        {{ companyDetail()?.partnerChamberOfCommerceNo }}
      </xemex-detail-field>
      <xemex-detail-field
        [label]="'companies.detailTabs.general.city' | translate"
        [loading]="isLoading()"
      >
        {{ companyDetail()?.partnerCity }}
      </xemex-detail-field>
      <xemex-detail-field
        [label]="'companies.detailTabs.general.zipcode' | translate"
        [loading]="isLoading()"
      >
        {{ companyDetail()?.partnerPostalcode }}
      </xemex-detail-field>
      <xemex-detail-field
        [label]="'companies.detailTabs.general.country' | translate"
        [loading]="isLoading()"
      >
        {{ companyDetail()?.partnerCountry }}
      </xemex-detail-field>
      <xemex-detail-field
        [label]="'companies.detailTabs.general.adminEmail' | translate"
        [loading]="isLoading()"
      >
        {{ companyDetail()?.partnerEmail }}
      </xemex-detail-field>
    </div>
  </xemex-card>

  @if (!isXemex()) {
    <xemex-my-company-default-meter-role
      [defaultMeterRole]="companyDetail()?.partnerDefaultMeterRole"
      [isLoading]="isLoading()"
      [isSaving]="isSavingDefaultMeterRole()"
      [userRole]="userRole()"
      (updateDefaultMeterRole)="updateDefaultMeterRole.emit($event)"
    ></xemex-my-company-default-meter-role>

    <xemex-card [title]="'companies.detailTabs.general.dataReadout.title' | translate">
      <xemex-tag
        cardTitleBadge
        state="neutral"
        icon="lock"
        [label]="'companies.detailTabs.general.dataReadout.managedByXemex' | translate"
      />
      <div class="flex flex-col gap-4">
        <div class="grid grid-cols-2 gap-4">
          <xemex-detail-field
            [label]="'companies.detailTabs.general.dataReadout.frequency' | translate"
          >
            {{ readoutFrequency().key | translate: readoutFrequency().params }}
          </xemex-detail-field>
          <xemex-detail-field
            [label]="'companies.detailTabs.general.dataReadout.appliesTo' | translate"
          >
            {{ 'companies.detailTabs.general.dataReadout.appliesToValue' | translate }}
          </xemex-detail-field>
        </div>
        <xemex-info-banner>
          {{ 'companies.detailTabs.general.dataReadout.contactNote' | translate }}
        </xemex-info-banner>
      </div>
    </xemex-card>
  }
</xemex-card-grid>
